import React, { useEffect, useRef, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard from 'src/components/shared/DashboardCard';
import { Button, Chip, Grid, IconButton, MenuItem, Modal, Paper, Select, Snackbar, TextField, Tooltip, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { EditorState, convertToRaw } from 'draft-js';
import ShowErrorMessage, { ShowSuccess } from 'src/components/CustomComponents/ShowMessages';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { ReqField } from 'src/components/CustomComponents/CustomLoader';
import { AddCircleOutlineRounded, AddCircleOutlined, CloseOutlined, CloseSharp, DeleteOutline } from '@mui/icons-material';
import { useMain } from '../hooks/useMain';
import TextInputs from 'src/components/inputs/TextInputs';
import SelectInputs from 'src/components/inputs/SelectInputs';

const initialValue = {
    serviceName: '',
    category: '',
    duration: '',
    price: '',
    membershipPrice: '',
    rewardPoints: '',
    serviceFor: '',
    branchDetails: ''
}

const AddService = () => {
    const [formData, setFormData] = useState(initialValue);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [branches, setBranches] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    }

    const getData = async () => {
        const res = await fetchAllBranch({ page: 1, limit: 50 });
        setBranches(res?.data);
    }

    const { createService, fetchAllBranch } = useMain();

    const handleSubmit = async () => {
       
        const { serviceName, category, duration, price, membershipPrice, rewardPoints, serviceFor, branchDetails } = formData;
        if (serviceName.trim() === '') return setErrorMessage('Service Name is Required');
        if (category === '') return setErrorMessage('Category is Required');
        if (duration === '') return setErrorMessage('Duration is Required');
        if (price === '') return setErrorMessage('Price is Required');
        if (membershipPrice === '') return setErrorMessage('Membership Price is Required');
        if (rewardPoints === '') return setErrorMessage('Reward Points is Required');
        if (serviceFor === '') return setErrorMessage('Service For is Required');
        if (branchDetails === '') return setErrorMessage('Branch is required');
        setShowLoader(true);

        const res = await createService(JSON.stringify({
            ...formData,
            price: Number(price),
            membershipPrice: Number(membershipPrice),
            rewardPoints: Number(rewardPoints),
            duration: Number(duration),
        }));

        if (res?.status === 'success') {
            setSuccessMessage('Service Successfully Created');
            setTimeout(() => {
                setSuccessMessage('');
            }, 7000);
            setFormData(initialValue);
            setErrorMessage('');
            setShowLoader(false);
        } else {
            setErrorMessage(res?.message);
            setTimeout(() => {
                setErrorMessage('');
            }, 7000);
            setFormData(initialValue);
            setShowLoader(false);
        }
    };

    useEffect(() => {
        getData();

        return () => { }
    }, [])

    return (
        <PageContainer title="Add Service" description="this is add Service">
            <DashboardCard title="Add Service">
                <Snackbar
                    open={errorMessage === '' ? false : true}
                    autoHideDuration={6000}
                    onClose={() => {
                        setErrorMessage('');
                    }}
                    severity="error"
                    message={errorMessage}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                />
                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Service Name'}
                                name={'serviceName'}
                                value={formData?.serviceName}
                                handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Membership Price'}
                                name={'membershipPrice'}
                                value={formData?.membershipPrice}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Category'}
                                name={'category'}
                                value={formData?.category}
                                handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Reward Points'}
                                name={'rewardPoints'}
                                value={formData?.rewardPoints}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Duration'}
                                name={'duration'}
                                value={formData?.duration}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Service For'}
                                name={'serviceFor'}
                                value={formData?.serviceFor}
                                handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Price'}
                                name={'price'}
                                value={formData?.price}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <SelectInputs
                                title={'Select Branch'}
                                options={branches}
                                name={'branchDetails'}
                                value={formData?.branchDetails}
                                handleChange={handleChange}
                                optionTitle={'branchName'}
                                optionValue={'_id'}
                            />
                        </Grid>
                    </Grid>
                </Box>

                {showLoader && <ShowLoader value={showLoader} />}
                {successMessage != '' && <ShowSuccess message={successMessage} />}

                <div style={{ width: '200px', margin: '3rem auto' }}>
                    <Button
                        variant="contained"
                        fullWidth
                        price="primary"
                        target="_blank"
                        sx={{
                            background: '#6174DD'
                        }}
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                </div>
            </DashboardCard>
        </PageContainer>
    )
}

export default AddService